import React from 'react';
import { VIEWER_HOOKS } from '@wix/pricing-plans-common/hooks';
import { Divider as Component } from '@wix/wix-ui-tpa/cssVars';
import { classes } from './StepDivider.st.css';

export const StepDivider = () => (
  <Component className={classes.root} data-hook={VIEWER_HOOKS.STEP_DIVIDER} direction="horizontal" />
);
